import type { RouteRecordRaw } from 'vue-router';

export const featureItemRoutes: Array<RouteRecordRaw> = [
  {
    path: '/feature/item',
    name: 'featureItem',
    redirect: '/feature/item/list',
    component: () => import('pages/trade/admin/featureItem/FeatureItem.vue'),
    meta: {
      title: 'FeatureItems',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'featureItemList',
        component: () => import('pages/trade/admin/featureItem/FeatureItemList.vue'),
        meta: {
          title: 'FeatureItems List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'featureItemDetail',
        component: () => import('pages/trade/admin/featureItem/FeatureItemDetail.vue'),
        meta: {
          title: 'FeatureItem Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'featureItemNew',
        component: () => import('pages/trade/admin/featureItem/FeatureItemNew.vue'),
        meta: {
          title: 'New FeatureItem',
          requiresAuth: true,
        },
      },
    ],
  },
];
